define("calendar/components/calendar/stories/vis-timeline", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/utils", "@ember/service", "lodash", "moment", "vis-timeline/standalone", "later/helpers/profile-color-outline-class", "later/utils/time-format"], function (_exports, _component, _templateFactory, _component2, _object, _utils, _service, _lodash, _moment, _standalone, _profileColorOutlineClass, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _buildStoryDataObjects, _calculateTimeDroppedTo, _generateDateRange, _generateStoryClasses, _generateStoryContent, _updateTimelineStories, _handleStoryMove;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/utils",0,"@ember/service",0,"lodash",0,"moment",0,"vis-timeline/standalone",0,"later/helpers/profile-color-outline-class",0,"later/utils/time-format",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cST--container--top ember-view {{if @selectedStory "has--selected"}}"
    {{did-update
      this.updateVisTimeline
      @socialProfile.profileColorClass
      this.startMoment
      this.endMoment
      this.storiesHaveUpdated
    }}
    {{droppable onDrop=this.handleDrop}}
  >
    <div class="cST--header">
      <span class="cST--header__title">
        {{t "stories.timeline"}}
      </span>
    </div>
    <div class="cST--content eST--timeline gd--story--2" {{did-insert this.drawTimeline}} {{perfect-scroll}}></div>
    {{#unless @showStoryEditor}}
      <div class="cST--timeline__hint" {{on "click" @goToCalendar}}>
        {{t "stories.exit_to_edit_posts"}}
      </div>
    {{/unless}}
    {{#if @showNewStoryDropZone}}
      <div class="cDZ--dropzoneWrapper--stories">
        <div class="cDZ--dropzone">
          <span class="cDZ--dropzone__text">
            {{t "stories.timeline_dropzone_message"}}
          </span>
        </div>
      </div>
    {{/if}}
  </div>
  
  */
  {
    "id": "Z3ymOiAq",
    "block": "[[[11,0],[16,0,[29,[\"cST--container--top ember-view \",[52,[30,1],\"has--selected\"]]]],[4,[38,1],[[30,0,[\"updateVisTimeline\"]],[30,2,[\"profileColorClass\"]],[30,0,[\"startMoment\"]],[30,0,[\"endMoment\"]],[30,0,[\"storiesHaveUpdated\"]]],null],[4,[38,2],null,[[\"onDrop\"],[[30,0,[\"handleDrop\"]]]]],[12],[1,\"\\n  \"],[10,0],[14,0,\"cST--header\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"cST--header__title\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"stories.timeline\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[11,0],[24,0,\"cST--content eST--timeline gd--story--2\"],[4,[38,4],[[30,0,[\"drawTimeline\"]]],null],[4,[38,5],null,null],[12],[13],[1,\"\\n\"],[41,[51,[30,3]],[[[1,\"    \"],[11,0],[24,0,\"cST--timeline__hint\"],[4,[38,7],[\"click\",[30,4]],null],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"stories.exit_to_edit_posts\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[41,[30,5],[[[1,\"    \"],[10,0],[14,0,\"cDZ--dropzoneWrapper--stories\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cDZ--dropzone\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"cDZ--dropzone__text\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"stories.timeline_dropzone_message\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"@selectedStory\",\"@socialProfile\",\"@showStoryEditor\",\"@goToCalendar\",\"@showNewStoryDropZone\"],false,[\"if\",\"did-update\",\"droppable\",\"t\",\"did-insert\",\"perfect-scroll\",\"unless\",\"on\"]]",
    "moduleName": "calendar/components/calendar/stories/vis-timeline.hbs",
    "isStrictMode": false
  });

  let VisTimelineComponent = (_dec = (0, _service.inject)('config'), (_class = (_buildStoryDataObjects = /*#__PURE__*/new WeakSet(), _calculateTimeDroppedTo = /*#__PURE__*/new WeakSet(), _generateDateRange = /*#__PURE__*/new WeakSet(), _generateStoryClasses = /*#__PURE__*/new WeakSet(), _generateStoryContent = /*#__PURE__*/new WeakSet(), _updateTimelineStories = /*#__PURE__*/new WeakSet(), _handleStoryMove = /*#__PURE__*/new WeakSet(), class VisTimelineComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _handleStoryMove);

      _classPrivateMethodInitSpec(this, _updateTimelineStories);

      _classPrivateMethodInitSpec(this, _generateStoryContent);

      _classPrivateMethodInitSpec(this, _generateStoryClasses);

      _classPrivateMethodInitSpec(this, _generateDateRange);

      _classPrivateMethodInitSpec(this, _calculateTimeDroppedTo);

      _classPrivateMethodInitSpec(this, _buildStoryDataObjects);

      _initializerDefineProperty(this, "calendarConfig", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _defineProperty(this, "visTimeline", null);

      _defineProperty(this, "storyItems", null);
    }

    get locales() {
      return {
        intlTranslations: {
          current: this.intl.t('calendar.vis_timeline.current'),
          time: this.intl.t('calendar.vis_timeline.time'),
          deleteSelected: this.intl.t('calendar.vis_timeline.deleteSelected')
        }
      };
    }

    get startMoment() {
      return (0, _moment.default)(this.calendarConfig.startTime).add(1, 'second');
    }

    get endMoment() {
      return (0, _moment.default)(this.calendarConfig.endTime).subtract(1, 'second');
    }

    get storiesHaveUpdated() {
      return (0, _lodash.isEqual)(_classPrivateMethodGet(this, _buildStoryDataObjects, _buildStoryDataObjects2).call(this), this.storyItems);
    }

    drawTimeline(container) {
      const timeZone = this.args.currentTimeZoneIdentifier;

      const utcOffset = _moment.default.tz(timeZone).utcOffset(); // Note: Configuration for the Timeline


      const options = { ..._classPrivateMethodGet(this, _generateDateRange, _generateDateRange2).call(this),
        horizontalScroll: false,
        zoomable: false,
        moveable: false,
        minHeight: 230,
        format: {
          minorLabels: {
            hour: 'ha'
          }
        },
        timeAxis: {
          scale: 'hour',
          step: 6
        },
        itemsAlwaysDraggable: true,
        orientation: {
          axis: 'top',
          item: 'top'
        },

        moment(date) {
          return (0, _moment.default)(date).utcOffset(utcOffset);
        },

        editable: {
          add: false,
          // add new items by double tapping
          updateTime: true,
          // drag items horizontally
          updateGroup: false,
          // drag items from one group to another
          remove: false,
          // delete an item by tapping the delete button top right
          overrideItems: false // allow these options to override item.editable

        },
        // Note: Instead of using built in locale support, use translations provided by ember-intl
        locales: this.locales,
        locale: 'intlTranslations',
        onMove: item => {
          _classPrivateMethodGet(this, _handleStoryMove, _handleStoryMove2).call(this, item.id, (0, _moment.default)(item.start));
        },

        snap(date) {
          const hour = _timeFormat.convert.hour().toMilliseconds();

          return Math.round(date / hour) * hour;
        }

      };

      const storyItems = _classPrivateMethodGet(this, _buildStoryDataObjects, _buildStoryDataObjects2).call(this);

      this.storyItems = storyItems;
      const visTimeline = new _standalone.Timeline(container, storyItems, options);
      this.visTimeline = visTimeline;
      visTimeline.on('select', properties => {
        const selectedItem = properties.items[0];

        if (selectedItem) {
          this.args.openStory(selectedItem);
        }
      });
      visTimeline.on('click', properties => {
        if ((0, _utils.isEmpty)(properties.item)) {
          this.args.discardChangesAndClose();
        }
      });
    }

    handleDrop(dragEvent) {
      const timeDroppedTo = _classPrivateMethodGet(this, _calculateTimeDroppedTo, _calculateTimeDroppedTo2).call(this, dragEvent);

      this.args.dropNewStoryOnTimeline(dragEvent, timeDroppedTo);
    }

    updateVisTimeline() {
      var _this$visTimeline, _this$visTimeline2;

      const storyItems = _classPrivateMethodGet(this, _buildStoryDataObjects, _buildStoryDataObjects2).call(this);

      (_this$visTimeline = this.visTimeline) === null || _this$visTimeline === void 0 ? void 0 : _this$visTimeline.setOptions(_classPrivateMethodGet(this, _generateDateRange, _generateDateRange2).call(this));

      _classPrivateMethodGet(this, _updateTimelineStories, _updateTimelineStories2).call(this);

      (_this$visTimeline2 = this.visTimeline) === null || _this$visTimeline2 === void 0 ? void 0 : _this$visTimeline2.setItems(storyItems);
      this.storyItems = storyItems;
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "drawTimeline", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "drawTimeline"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDrop", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateVisTimeline", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateVisTimeline"), _class.prototype)), _class));
  _exports.default = VisTimelineComponent;

  function _buildStoryDataObjects2() {
    const stories = this.args.stories.map(story => {
      const storyContent = _classPrivateMethodGet(this, _generateStoryContent, _generateStoryContent2).call(this, story);

      const storyClasses = _classPrivateMethodGet(this, _generateStoryClasses, _generateStoryClasses2).call(this, story);

      const canDragOnTimeline = (0, _utils.isEmpty)(this.args.selectedStory);
      const canDragStory = !story.isPosted && !story.isNew && !story.isSaving && canDragOnTimeline;
      return {
        id: story.id,
        className: storyClasses,
        content: storyContent,
        start: (0, _moment.default)(story.startTime),
        end: (0, _moment.default)(story.storyEndTime),
        editable: {
          updateTime: canDragStory,
          updateGroup: false,
          remove: false
        }
      };
    });
    return new _standalone.DataSet(stories);
  }

  function _calculateTimeDroppedTo2(dragEvent) {
    const timelineContainer = document.querySelector('.vis-center');
    const containerProperties = (timelineContainer === null || timelineContainer === void 0 ? void 0 : timelineContainer.getBoundingClientRect()) || {
      left: 0,
      width: 0
    };
    const {
      left,
      width
    } = containerProperties;
    const offsetEventX = dragEvent.pageX - 27; // hack to align drop time to left edge of dropped picture --GP

    const xValue = offsetEventX < left ? left : offsetEventX;
    const droppedTimelineDay = (xValue - left) / (width / 7);
    const startDayUnix = (0, _moment.default)(this.calendarConfig.startTime).add(1, 'second').unix();
    return Math.floor(startDayUnix + droppedTimelineDay * _timeFormat.convert.day().toSeconds());
  }

  function _generateDateRange2() {
    return {
      start: this.startMoment.toDate(),
      end: this.endMoment.toDate()
    };
  }

  function _generateStoryClasses2(story) {
    var _this$args$selectedSt;

    const storyClasses = [];
    const storyItemBaseClass = ((_this$args$selectedSt = this.args.selectedStory) === null || _this$args$selectedSt === void 0 ? void 0 : _this$args$selectedSt.id) == story.id ? 'is--selected' : 'is--unselected';
    storyClasses.push(storyItemBaseClass);
    storyClasses.push((0, _profileColorOutlineClass.profileColorOutlineClass)([this.args.socialProfile.profileColorClass]));

    if (story.isPosted) {
      storyClasses.push('is--posted');
    } // Note: Reason for '.get' https://github.com/typed-ember/ember-cli-typescript/issues/969


    if (story.get('isSaving')) {
      storyClasses.push('is--loading');
    }

    return storyClasses.join(' ');
  }

  function _generateStoryContent2(story) {
    const storyThumbnails = story.postMediaItemsThumbnails.map(pmiThumbnailUrl => "<span class='vis-item_img' style='background-image: url(".concat(pmiThumbnailUrl, ")'></span>"));
    const timeElement = document.createElement('span');
    timeElement.classList.add('vis-time');
    timeElement.innerHTML = (0, _moment.default)(story.startTime || '').tz(this.args.currentTimeZoneIdentifier).format('h:mm A');
    const thumbnailListElement = document.createElement('div');
    thumbnailListElement.classList.add('vis-list');
    thumbnailListElement.innerHTML = storyThumbnails.join('');
    const content = document.createElement('div');
    content.appendChild(timeElement);
    content.appendChild(thumbnailListElement);
    return content;
  }

  function _updateTimelineStories2() {
    var _this$visTimeline3;

    const storyItems = _classPrivateMethodGet(this, _buildStoryDataObjects, _buildStoryDataObjects2).call(this);

    (_this$visTimeline3 = this.visTimeline) === null || _this$visTimeline3 === void 0 ? void 0 : _this$visTimeline3.setItems(storyItems);
    this.storyItems = storyItems;
  }

  function _handleStoryMove2(storyId, itemNewStart) {
    const now = (0, _moment.default)().unix();
    const newStartTime = (0, _moment.default)(itemNewStart).unix();

    if (newStartTime <= now) {
      this.dialogManager.confirm(this.intl.t('calendar.cannot_schedule_in_past'), {
        description: this.intl.t('calendar.cannot_post_path_immediate'),
        confirmButton: this.intl.t('shared_phrases.publish_now')
      }).then(() => this.args.updateStoryTime(storyId, (0, _moment.default)().unix())).catch(() => _classPrivateMethodGet(this, _updateTimelineStories, _updateTimelineStories2).call(this));
    } else {
      this.args.updateStoryTime(storyId, newStartTime);
    }
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, VisTimelineComponent);
});